export var TABLE_HEAD_CLASS_PREFIX = 'TableHead';
export var tableHeadRootTestId = 'TableHeadRoot';